/* ============================================================
   IDIOTSHARK — panier Shopify + tout le bordel.
   Chaque connerie est une fonction : commente son appel dans
   boot() en bas pour la désactiver.
   ============================================================ */

const HOVERABLE = window.matchMedia('(hover: hover)').matches;
const CALME     = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
const pick      = a => a[Math.floor(Math.random() * a.length)];

/* ---------------- panier Shopify ---------------- */
async function cartState(){
  try {
    const r = await fetch((window.IS?.cartUrl || '/cart') + '.js', { headers:{ 'Accept':'application/json' } });
    return r.ok ? await r.json() : null;
  } catch { return null; }
}
async function paintCount(){
  const c = await cartState();
  if (!c) return;
  document.querySelectorAll('.cart-count').forEach(el => el.textContent = c.item_count);
}
async function addToCart(variantId, qty = 1){
  const r = await fetch(window.IS?.addUrl || '/cart/add.js', {
    method:'POST',
    headers:{ 'Content-Type':'application/json', 'Accept':'application/json' },
    body: JSON.stringify({ items:[{ id: variantId, quantity: qty }] })
  });
  if (!r.ok){
    let msg = "Shopify a dit non. Recharge la page.";
    try { const e = await r.json(); if (e.description) msg = e.description; } catch {}
    throw new Error(msg);
  }
  await paintCount();
  return r.json();
}

/* ---------------- toast ---------------- */
let toastTimer;
function toast(html){
  let el = document.querySelector('.toast');
  if (!el){ el = document.createElement('div'); el.className = 'toast'; document.body.appendChild(el); }
  el.innerHTML = html;
  document.getElementById('notif')?.classList.remove('show');
  requestAnimationFrame(() => el.classList.add('show'));
  clearTimeout(toastTimer);
  toastTimer = setTimeout(() => el.classList.remove('show'), 4000);
}

/* ---------------- secousse ---------------- */
function tilt(){
  if (CALME) return;
  document.body.classList.remove('shake');
  void document.body.offsetWidth;
  document.body.classList.add('shake');
  setTimeout(() => document.body.classList.remove('shake'), 520);
}

/* ---------------- jetons + tampon ---------------- */
function chips(x, y, n = 30){
  if (CALME) return;
  for (let i = 0; i < n; i++){
    const c = document.createElement('div');
    c.className = 'chip-p' + (i % 3 === 0 ? ' b' : '');
    c.style.left = x + 'px'; c.style.top = y + 'px';
    c.style.setProperty('--tx', (Math.random()*640-320).toFixed(0)+'px');
    c.style.setProperty('--ty', (Math.random()*-520-60).toFixed(0)+'px');
    c.style.setProperty('--rot', (Math.random()*1080-540).toFixed(0)+'deg');
    c.style.animationDelay = (Math.random()*.16).toFixed(2)+'s';
    document.body.appendChild(c);
    setTimeout(() => c.remove(), 1300);
  }
}
function stamp(word){
  if (CALME) return;
  let el = document.getElementById('stamp');
  if (!el){ el = document.createElement('div'); el.id = 'stamp'; el.innerHTML = '<b></b>'; document.body.appendChild(el); }
  el.querySelector('b').textContent = word;
  el.classList.remove('go'); void el.offsetWidth; el.classList.add('go');
  setTimeout(() => el.classList.remove('go'), 800);
}

/* ---------------- tableaux scrollables ---------------- */
function initTables(){
  document.querySelectorAll('.rte table').forEach(t => {
    if (t.parentElement.classList.contains('table-scroll')) return;
    const box = document.createElement('div');
    box.className = 'table-scroll';
    t.parentNode.insertBefore(box, t);
    box.appendChild(t);
  });
}

/* ---------------- menu mobile ---------------- */
function initBurger(){
  const b = document.getElementById('burger');
  const nav = document.getElementById('nav');
  if (!b || !nav) return;
  b.addEventListener('click', () => {
    const open = nav.classList.toggle('open');
    b.setAttribute('aria-expanded', open ? 'true' : 'false');
  });
  nav.querySelectorAll('a').forEach(a => a.addEventListener('click', () => {
    nav.classList.remove('open');
    b.setAttribute('aria-expanded', 'false');
  }));
  addEventListener('resize', () => {
    if (innerWidth > 760){ nav.classList.remove('open'); b.setAttribute('aria-expanded','false'); }
  });
}

/* ---------------- barre de scroll ---------------- */
function initTiltBar(){
  const bar = document.createElement('div');
  bar.id = 'tiltbar';
  document.body.appendChild(bar);
  const paint = () => {
    const h = document.documentElement.scrollHeight - innerHeight;
    bar.style.width = (h > 0 ? (scrollY/h)*100 : 0) + '%';
  };
  addEventListener('scroll', paint, { passive:true });
  paint();
}

/* ---------------- notifs "en direct" ---------------- */
const ACHETEURS = [
  ['Kevin, Lille',       "vient d'en prendre deux, au cas où"],
  ['Sofiane, Marseille', "a commandé au lieu de finir son mail"],
  ['Thomas, Nantes',     "hésitait depuis mardi. Plus maintenant"],
  ['Enzo, Toulouse',     "a pris la 3XL pour être large dans sa tête"],
  ['Rayan, Paris',       "reprend le même pour la 3ᵉ fois"],
  ['Jordan, Bordeaux',   "a craqué en 40 secondes, record du jour"],
  ['Maxime, Rennes',     "a acheté le requin, pas l'inverse"],
  ['Léa, Lyon',          "a commandé pendant une réunion"],
];
function initNotifs(){
  if (!(window.IS && window.IS.hype)) return;
  if (CALME) return;
  const box = document.createElement('div');
  box.id = 'notif';
  document.body.appendChild(box);
  let i = Math.floor(Math.random()*ACHETEURS.length);
  const show = () => {
    const [qui, quoi] = ACHETEURS[i++ % ACHETEURS.length];
    box.innerHTML = `<b>${qui}</b><p>${quoi}</p><small>il y a ${1+Math.floor(Math.random()*9)} min · vérifié par personne</small>`;
    box.classList.add('show');
    setTimeout(() => box.classList.remove('show'), 4600);
  };
  setTimeout(show, 3500);
  setInterval(show, 12000);
}

/* ---------------- compteur de dégénérés ---------------- */
function initLive(){
  if (!(window.IS && window.IS.hype)) return;
  document.querySelectorAll('[data-live]').forEach(el => {
    let n = 30 + Math.floor(Math.random()*40);
    el.textContent = n;
    setInterval(() => { n = Math.max(11, n + Math.floor(Math.random()*9) - 4); el.textContent = n; }, 2600);
  });
}

/* ---------------- retourner les tees au doigt ---------------- */
function initFlip(){
  if (HOVERABLE) return;
  document.querySelectorAll('.flip-hint').forEach(hint => {
    hint.textContent = 'Le dos ↺';
    hint.addEventListener('click', e => {
      e.preventDefault();
      const card = hint.closest('.card');
      card.classList.toggle('flipped');
      hint.textContent = card.classList.contains('flipped') ? 'La face ↺' : 'Le dos ↺';
    });
  });
  const frame = document.querySelector('.hero-shot .frame');
  if (frame){
    const s = document.getElementById('flip-sticker');
    if (s) s.innerHTML = 'Tape le tee →<br>tu vois le dos';
    frame.addEventListener('click', () => frame.classList.toggle('flipped'));
  }
}

/* ---------------- bouton fuyard ---------------- */
function initBroke(){
  const btn  = document.getElementById('broke');
  const zone = document.getElementById('escape');
  if (!btn || !zone) return;
  const msg  = zone.dataset.caught || "Fais pas genre. On sait très bien que tu peux te le payer.";
  const RAGE = ["Non.", "Essaie encore.", "Menteur.", "T'es sûr ?", "Mytho."];
  let dodges = 0;
  const move = () => {
    if (CALME) return;
    if (++dodges > 4){ zone.innerHTML = `<div class="broke-msg">${msg}</div>`; return; }
    btn.style.left = Math.random() * Math.max(0, zone.clientWidth  - btn.offsetWidth)  + 'px';
    btn.style.top  = Math.random() * Math.max(0, zone.clientHeight - btn.offsetHeight) + 'px';
    btn.textContent = pick(RAGE);
  };
  btn.addEventListener('mouseenter', move);
  btn.addEventListener('click', e => { e.preventDefault(); move(); tilt(); });
}

/* ---------------- code secret ---------------- */
function initSecret(){
  let buf = '';
  addEventListener('keydown', e => {
    if (e.key.length !== 1) return;
    if (/input|textarea/i.test(document.activeElement?.tagName || '')) return;
    buf = (buf + e.key.toLowerCase()).slice(-5);
    if (buf === 'shark'){
      document.body.classList.toggle('chaos');
      tilt(); chips(innerWidth/2, innerHeight/2, 40); stamp('Aïe');
      toast(document.body.classList.contains('chaos')
        ? "Mode requin activé. Retape « shark » pour que ça s'arrête."
        : "Voilà, c'est calme. Content ?");
    }
  });
}

/* ---------------- bandeau cookies ---------------- */
function initCookies(){
  const bar = document.getElementById('cookies');
  if (!bar) return;
  if (sessionStorage.getItem('is.cookies')){ bar.remove(); return; }
  bar.hidden = false;
  bar.querySelector('button').onclick = () => {
    try { sessionStorage.setItem('is.cookies','1'); } catch {}
    bar.remove();
    toast("Évidemment.");
  };
}

/* ---------------- page produit ---------------- */
function initProduct(){
  const form = document.getElementById('product-form');
  if (!form) return;

  const sizes  = document.getElementById('sizes');
  const joke   = document.getElementById('joke');
  const addBtn = document.getElementById('add');
  const JOKES  = {
    'S':   "S comme « si je me remets au sport en janvier ».",
    'M':   "La taille des gens raisonnables. Tu la prendras pas.",
    'L':   "La taille du peuple. Bon choix.",
    'XL':  "XL comme « X-tra Large, et j'assume ».",
    '2XL': "Confortable. C'est le mot qu'on utilise.",
    '3XL': "Large dehors, large dans la tête.",
    '4XL': "À ce stade c'est plus un t-shirt, c'est un abri.",
    '5XL': "Le requin lui-même rentre dedans.",
  };
  const hidden = document.getElementById('variant-id');
  let variantId = null;

  /* « 2 XL » côté Shopify, « 2XL » dans la liste : on normalise */
  const jokeKey = el => (el.dataset.size || '').replace(/\s+/g, '').toUpperCase();

  sizes?.querySelectorAll('button').forEach(b => {
    b.addEventListener('mouseenter', () => {
      if (joke) joke.textContent = b.disabled ? "Épuisée. Fallait venir plus tôt." : (JOKES[jokeKey(b)] || '');
    });
    if (b.disabled) return;
    b.addEventListener('click', () => {
      sizes.querySelectorAll('button').forEach(x => x.classList.remove('on'));
      b.classList.add('on');
      variantId = b.dataset.variantId;
      if (hidden) hidden.value = variantId;
      if (joke) joke.textContent = JOKES[jokeKey(b)] || '';
    });
  });

  form.addEventListener('submit', async e => {
    e.preventDefault();
    if (!variantId){
      toast("Choisis une taille. On improvise pas sur tout dans la vie.");
      tilt();
      sizes?.scrollIntoView({ block:'center' });
      return;
    }
    addBtn.disabled = true;
    const label = addBtn.textContent;
    addBtn.textContent = 'Ça part…';
    try {
      await addToCart(Number(variantId));
      const r = addBtn.getBoundingClientRect();
      chips(r.left + r.width/2, r.top + r.height/2, 34);
      stamp('Mordu');
      toast(`Ajouté. <a href="${window.IS?.cartUrl || '/cart'}">Voir le panier</a>`);
    } catch (err){
      toast(err.message);
    } finally {
      addBtn.disabled = false;
      addBtn.textContent = label;
    }
  });

  /* galerie */
  document.querySelectorAll('.thumbs button').forEach(b => {
    b.addEventListener('click', () => {
      document.querySelectorAll('.thumbs button').forEach(x => x.classList.remove('on'));
      b.classList.add('on');
      const main = document.getElementById('main-img');
      /* image_tag pose un srcset qui l'emporte sur src : on le retire */
      main.removeAttribute('srcset');
      main.removeAttribute('sizes');
      main.src = b.dataset.full;
      main.alt = b.dataset.alt || '';
    });
  });

  /* minuteur décoratif */
  const timer = document.getElementById('timer');
  if (timer){
    let s = 599;
    setInterval(() => {
      if (--s < 0){ s = 599; toast("On t'a rallongé le temps. On est sympa."); }
      timer.textContent = String(Math.floor(s/60)).padStart(2,'0') + ':' + String(s%60).padStart(2,'0');
    }, 1000);
  }
}

/* ---------------- panier (page) ---------------- */
function initCartPage(){
  document.querySelectorAll('[data-qty]').forEach(box => {
    const input = box.querySelector('input');
    box.querySelectorAll('button').forEach(b => {
      b.addEventListener('click', () => {
        const step = Number(b.dataset.step);
        input.value = Math.max(0, Number(input.value) + step);
        input.form.submit();
      });
    });
  });
}

/* ---------------- boot ---------------- */
function boot(){
  paintCount();
  initTables();
  initBurger();
  initTiltBar();
  initNotifs();
  initLive();
  initFlip();
  initBroke();
  initSecret();
  // initCookies();   // Shopify affiche déjà un vrai bandeau de consentement
  initProduct();
  initCartPage();

  const TILT_STEPS = [
    { stamp: 'Aïe',       toast: 'Aïe.',                            chips: 20 },
    { stamp: 'Arrête',    toast: 'Arrête.',                         chips: 35 },
    { stamp: 'ÇA SUFFIT', toast: 'ÇA SUFFIT.',                      chips: 55 },
    { stamp: 'MIAM',      toast: 'JE VAIS TE BOUFFER SALE BÂTARD',  chips: 90 }
  ];
  let tiltStep = 0;
  document.querySelectorAll('[data-tilt]').forEach(el => {
    el.addEventListener('click', e => {
      e.preventDefault();
      const step = TILT_STEPS[Math.min(tiltStep, TILT_STEPS.length - 1)];
      tiltStep++;
      tilt();
      chips(e.clientX || innerWidth/2, e.clientY || innerHeight/2, step.chips);
      stamp(step.stamp);
      toast(step.toast);
    });
  });

  /* bouton « acheter » en haut de fiche */
  document.querySelectorAll('[data-buy]').forEach(el => {
    el.addEventListener('click', () => {
      const chosen = document.querySelector('#sizes button.on');
      const form = document.getElementById('product-form');
      if (chosen && form) { form.requestSubmit ? form.requestSubmit() : form.submit(); return; }
      const sizes = document.getElementById('sizes');
      if (!sizes) return;
      sizes.scrollIntoView({ block: 'center', behavior: CALME ? 'auto' : 'smooth' });
      sizes.classList.remove('askme'); void sizes.offsetWidth; sizes.classList.add('askme');
      toast('Ta taille d\'abord. On est pas des sauvages.');
    });
  });

  document.querySelectorAll('[data-cart-open]').forEach(el => {
    el.addEventListener('click', async e => {
      e.preventDefault();
      const c = await cartState();
      if (c && c.item_count) location.href = window.IS?.cartUrl || '/cart';
      else toast("Panier vide. C'est triste à voir.");
    });
  });
}
document.addEventListener('DOMContentLoaded', boot);
